import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";

const ConfirmDeleteModal = ({ open, onClose, onConfirm, title, message }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title || "Confirm Deletion"}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message || "Are you sure you want to delete the selected item(s)?"}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} size="small">Cancel</Button>
                <Button onClick={onConfirm} color="error" size="small">Delete</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteModal;
